import React from 'react';
import Helmet from 'react-helmet';

import { Section } from '../Section';
import { Contact } from './Contact';
import { Map } from './Map';
import { OpeningHours } from './OpeningHours';

export const ContactSection = ({
  bigImage,
  heading,
  marketingActivated,
  marketing,
  phoneNumber,
  contact,
  allPosts,
  scrollToRef,
  active,
  slug
}) => [
  active && (
    <Helmet key="helmet">
      <meta property="og:url" content={`https://www.styrelsen.nu/${slug}`} />
    </Helmet>
  ),
  <Section
    key="section"
    heading={heading}
    marketing={marketingActivated && marketing}
    image={bigImage}
    scrollToRef={scrollToRef}
  />,
  <OpeningHours key="hours" openingHours={contact.openingHours} />,
  <Contact
    key="contact"
    {...contact}
    allPosts={allPosts}
    phoneNumber={phoneNumber}
  />,
  <Map key="map" />
];



// WEBPACK FOOTER //
// ./app/components/ContactSection/ContactSection.js